import React from 'react';
import { Link } from 'react-router-dom';

const QuickAccess: React.FC = () => {
  const sections = [
    {
      title: 'Informations Générales',
      description: 'Conditions d\'admission, inscription, objectifs et organisation des études',
      icon: '📚',
      path: '/formations#informations-generales',
      color: 'from-blue-500 to-blue-600'
    },
    {
      title: 'Historique',
      description: 'Découvrez l\'histoire et l\'évolution de notre institut',
      icon: '📜',
      path: '/a-propos#historique',
      color: 'from-green-500 to-green-600'
    },
    {
      title: 'Critères de Réussite',
      description: 'Système d\'évaluation et conditions de passage',
      icon: '🎯',
      path: '/formations#criteres-reussite',
      color: 'from-purple-500 to-purple-600'
    },
    {
      title: 'Mot du Directeur',
      description: 'Message du directeur fondateur de l\'ISTMECH',
      icon: '👨‍💼',
      path: '/a-propos#mot-directeur',
      color: 'from-orange-500 to-orange-600'
    },
    {
      title: 'Règlements',
      description: 'Règles et procédures de l\'institut',
      icon: '📋',
      path: '/vie-etudiante#reglements',
      color: 'from-red-500 to-red-600'
    },
    {
      title: 'Contact',
      description: 'Nous contacter pour plus d\'informations',
      icon: '📞',
      path: '/contact#contact',
      color: 'from-teal-500 to-teal-600'
    }
  ];

  return (
    <section className="py-16 bg-gray-50 dark:bg-gray-900 transition-colors duration-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
            Accès Rapide
          </h2>
          <p className="text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
            Explorez les différentes sections de notre institut et découvrez tout ce que l'ISTMECH a à offrir
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {sections.map((section, index) => (
            <Link
              key={index}
              to={section.path}
              className="group bg-white dark:bg-gray-800 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden transform hover:-translate-y-1"
            >
              <div className={`h-2 bg-gradient-to-r ${section.color}`}></div>
              <div className="p-6">
                <div className="flex items-center mb-4">
                  <span className="text-3xl mr-3">{section.icon}</span>
                  <h3 className="text-xl font-semibold text-gray-900 dark:text-white group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors duration-200">
                    {section.title}
                  </h3>
                </div>
                <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
                  {section.description}
                </p>
                <div className="mt-4 flex items-center text-blue-600 dark:text-blue-400 font-medium">
                  <span className="text-sm">En savoir plus</span>
                  <svg className="w-4 h-4 ml-2 transform group-hover:translate-x-1 transition-transform duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default QuickAccess;
